import api from './api';
import type { SemanticEntityType } from './semantics-api';

export interface BusinessSource {
  id: string;
  name: string;
  sourceType: string;
  integrationId: string;
  mode: 'ingestion' | 'passthrough' | 'federated';
  healthStatus: string;
  lastSyncAt: string | null;
}

export interface BusinessDossier {
  id: string;
  name: string;
  sources: BusinessSource[];
  semantics: { total: number; byType: Record<SemanticEntityType, number>; proposed: number };
  queries30d: number;
  attention: number;
  wiki: {
    exists: boolean;
    pageId: string | null;
    /** False while the page is still the untouched bootstrap template. */
    started: boolean;
    title: string | null;
    version: number | null;
    updatedAt: string | null;
    updatedByType: string | null;
    excerpt: string | null;
  };
}

export const businessesApi = {
  getOverview: async (): Promise<BusinessDossier[]> => {
    const { data } = await api.get('/api/businesses/overview');
    return data.data as BusinessDossier[];
  },
};
